import styled from "styled-components"

export const Component = styled.button<{ $selected?: boolean; $soldOut?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
  width: 100%;
  padding: 10px 12px;
  margin-bottom: 6px;
  border-radius: 6px;
  border: 1px solid
    ${({ $selected, theme }) => ($selected ? theme.colors.blue.main : "#ccc")};
  background: ${({ $selected }) =>
    $selected ? "rgba(0, 97, 230, 0.08)" : "none"};
  text-align: left;
  cursor: ${({ $soldOut }) => ($soldOut ? "not-allowed" : "pointer")};

  &:last-child {
    margin-bottom: 0;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.blue.main};
    outline-offset: 2px;
  }
`

export const Info = styled.div`
  display: flex;
  flex-direction: column;
`

export const Name = styled.span`
  font-size: 16px;
  font-weight: 900;
  color: ${({ theme }) => theme.colors.black.secondary};
`

export const Seats = styled.span`
  font-size: 16px;
  font-weight: 400;
  color: #6b7280;
`

export const PriceArea = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const Price = styled.span`
  font-size: 16px;
  color: #6b7280;
`

export const SoldOut = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: #6b7280;
`
